import { render } from "./pnc_maternal_tratment.vue?vue&type=template&id=53f10f24&scoped=true"
import script from "./pnc_maternal_tratment.vue?vue&type=script&lang=js"
export * from "./pnc_maternal_tratment.vue?vue&type=script&lang=js"

import "./pnc_maternal_tratment.vue?vue&type=style&index=0&id=53f10f24&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f10f24"]])

export default __exports__